import { useMemo } from 'react';

import { CurrentUserView, CurrentUserViewOptions } from '../views/users/CurrentUserView/CurrentUserView';
import { useApiView } from './useApiView';

export const useCurrentUser = ({
  enabled = true,
  includeProperties = false
}: CurrentUserViewOptions = {}): CurrentUserView => {
  const view = useMemo(() => new CurrentUserView({ enabled, includeProperties }), [enabled, includeProperties]);
  return useApiView(view);
};
